import * as React from "react";

import "./my-listings-loading-modal.scss";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {DeprecatedModalService2}   from "@Common/ui-components/heavy/common/design2/modal-service/modal-service";

export const MyListingsLoadingModal = ({next: rootNext}) => cs(
    ["modal", ({}, next) => DeprecatedModalService2({
        hideCloseButton: true,
        render: ({resolve}, rm) => ({
            size: "small",
            content: next({
                close: () => {
                    resolve(true);
                    rm()
                }
            }),
        }),
        next: rootNext,
    })],
    consumeContext("themeScheme"),
    ({modal, themeScheme}) => (
        <div className="my-listings-loading-modal-7s5">

            <div className="title" style={{color: themeScheme.xpresso.menuBackgroundColor}}>
                My Listings
            </div>

            <div className="messages">
                <div className="message">
                    You will now be directed to a list of products that can be used to market this listing.
                </div>
                <div className="message">
                    Please select a product to customize, your listing data will be pulled into the design during customization.
                </div>
            </div>


            <div className="buttons">
                <button {...{
                    className: "button",
                    "xd-qa-type": "button",
                    "xd-qa-name": "Continue",
                    onClick: () => modal.close(),
                }}>Continue</button>
            </div>
        </div>
    ),
);
